import React, { useState } from 'react';
import { Info } from 'lucide-react';
import { toast } from 'react-toastify';

const EnquiryForm = ({ source, user_id }) => {
  const fullUrl = window.location.href;
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    remark: '',
    user_id,
    enquiry_source: source,
    source: fullUrl,
    main_id:"HBTR0001"
  });
  const url = process.env.REACT_APP_LINK
  const [errors, setErrors] = useState({});
  const [submittedOnce, setSubmittedOnce] = useState(false);
  const [load, setLoad] = useState(true);

  const validateField = (name, value) => {
    if (name === 'name') return value.trim() === '';
    if (name === 'mobile') return value.length !== 10;
    if (name === 'remark') return value.trim() === '';
    return false;
  };

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === 'mobile') {
      value = value.replace(/\D/g, '');
      if (value.startsWith('91') && value.length > 10) value = value.slice(2);
      else if (value.startsWith('0') && value.length > 10) value = value.slice(1);
      value = value.slice(0, 10);
    }

    setFormData({ ...formData, [name]: value });

    if (submittedOnce) {
      setErrors(prev => ({ ...prev, [name]: validateField(name, value) }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmittedOnce(true);

    const nameError = validateField('name', formData.name);
    const mobileError = validateField('mobile', formData.mobile);
    const remarkError = validateField('remark', formData.remark);

    const newErrors = { name: nameError, mobile: mobileError, remark: remarkError };
    setErrors(newErrors);

    if (nameError || mobileError || remarkError) {
      toast.error('Please fix the highlighted fields.');
      return;
    }

    setLoad(false);
    try {
      const response = await fetch(`${url}/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        alert('Details sent! Our team will contact you soon.');
        setFormData({ ...formData, name: '', mobile: '', remark: '' });
        setErrors({});
        setSubmittedOnce(false);
      } else {
        toast.error('Submission failed, try again.');
      }
    } catch (error) {
      toast.error('Network error, try again later.');
    } finally {
      setLoad(true);
    }
  };

  return (
    <>
      <div className="enquiry-form-container-fb">
        <h2 className="feed-modal-heading">
          Send Us Your Enquiry
        </h2>
        <form onSubmit={handleSubmit}>
          {/* Name Input */}
          <div className="form-group-fb" style={{ position: 'relative' }}>
            <label htmlFor="name">Your Name</label>
            <input
              id="name"
              name="name"
              type="text"
              placeholder="Your Name"
              value={formData.name}
              onChange={handleChange}
              className={errors.name ? 'input-error' : ''}
              style={{ paddingRight: '35px' }}
            />
            {errors.name && (
              <Info
                size={18}
                className="input-icon"
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '40px',
                  pointerEvents: 'none',
                  color: 'red',
                }}
              />
            )}
          </div>

          {/* Mobile Input */}
          <div className="form-group-fb" style={{ position: 'relative' }}>
            <label htmlFor="mobile">Your Phone Number</label>
            <input
              id="mobile"
              name="mobile"
              type="tel"
              placeholder="Your Phone Number"
              value={formData.mobile}
              onChange={handleChange}
              className={errors.mobile ? 'input-error' : ''}
              style={{ paddingRight: '35px' }}
            />
            {errors.mobile && (
              <Info
                size={18}
                className="input-icon"
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '40px',
                  pointerEvents: 'none',
                  color: 'red',
                }}
              />
            )}
          </div>

          {/* Remark Textarea */}
          <div className="form-group-fb" style={{ position: 'relative' }}>
            <label htmlFor="remark">Message</label>
            <textarea
              id="remark"
              name="remark"
              placeholder="Your Message"
              rows={5}
              value={formData.remark}
              onChange={handleChange}
              className={errors.remark ? 'input-error' : ''}
              style={{ paddingRight: '35px' }}
            />
            {errors.remark && (
              <Info
                size={18}
                className="input-icon"
                style={{
                  position: 'absolute',
                  right: '10px',
                  top: '40px',
                  pointerEvents: 'none',
                  color: 'red',
                }}
              />
            )}
          </div>

          <button type="submit" className="submit-btn-fb" disabled={!load}>
            {load ? 'Send Inquiry' : 'Sending...'}
          </button>
        </form>
      </div>
    </>
  );
};

export default EnquiryForm;
